import { _ as _extends } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default from 'react';

var AddIconSvg = (props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Arrow-Left-Copy-5",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("circle", {
  id: "Oval-35",
  className: "motorway-svg-stroke",
  strokeWidth: "2",
  cx: "12",
  cy: "12",
  r: "9"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12,8.5 L12,15.5",
  id: "Line",
  className: "motorway-svg-stroke",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12,8.5 L12,15.5",
  id: "Line",
  className: "motorway-svg-stroke",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) "
}))));

var DownIconSvg = (props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React__default.createElement("polyline", {
  className: "motorway-svg-stroke",
  strokeWidth: "2",
  points: "5 9 11.9166237 16 19 9"
}))));

var LoadingIconSvg = (props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: "20px",
  height: "20px",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React__default.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/loading",
  transform: "translate(-2.000000, -2.000000)"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "noun_1145291_cc",
  transform: "translate(2.000000, 3.000000)"
}, /*#__PURE__*/React__default.createElement("g", {
  className: "motorway-svg-fill motorway-svg-stroke",
  id: "Group",
  transform: "translate(0.227273, 0.000000)",
  fill: "#000000",
  fillRule: "nonzero",
  stroke: "#1D1D1B",
  strokeWidth: "0.5"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M9.77272727,3.456 C9.39772727,3.456 9.09090909,3.132 9.09090909,2.736 L9.09090909,0.72 C9.09090909,0.324 9.39772727,0 9.77272727,0 C10.1477273,0 10.4545455,0.324 10.4545455,0.72 L10.4545455,2.772 C10.4545455,3.132 10.1477273,3.456 9.77272727,3.456 Z M9.77272727,18 C9.39772727,18 9.09090909,17.676 9.09090909,17.28 L9.09090909,15.228 C9.09090909,14.832 9.39772727,14.508 9.77272727,14.508 C10.1477273,14.508 10.4545455,14.832 10.4545455,15.228 L10.4545455,17.28 C10.4545455,17.676 10.1477273,18 9.77272727,18 Z M18.1363636,9.675 L16.0636364,9.675 C15.6636364,9.675 15.3363636,9.37125 15.3363636,9 C15.3363636,8.62875 15.6636364,8.325 16.0636364,8.325 L18.1363636,8.325 C18.5363636,8.325 18.8636364,8.62875 18.8636364,9 C18.8636364,9.37125 18.5363636,9.675 18.1363636,9.675 Z M3.44545455,9.675 L1.40909091,9.675 C1.00909091,9.675 0.681818182,9.37125 0.681818182,9 C0.681818182,8.62875 1.00909091,8.325 1.40909091,8.325 L3.48181818,8.325 C3.88181818,8.325 4.20909091,8.62875 4.20909091,9 C4.20909091,9.37125 3.84545455,9.675 3.44545455,9.675 Z M15.5636364,15.417 C15.3818182,15.417 15.2,15.345 15.0545455,15.201 L13.6,13.761 C13.3090909,13.473 13.3090909,13.041 13.6,12.753 C13.8909091,12.465 14.3272727,12.465 14.6181818,12.753 L16.0727273,14.193 C16.3636364,14.481 16.3636364,14.913 16.0727273,15.201 C15.9272727,15.345 15.7454545,15.417 15.5636364,15.417 Z M5.16363636,5.121 C4.98181818,5.121 4.8,5.049 4.65454545,4.905 L3.2,3.465 C2.90909091,3.177 2.90909091,2.745 3.2,2.457 C3.49090909,2.169 3.92727273,2.169 4.21818182,2.457 L5.67272727,3.897 C5.96363636,4.185 5.96363636,4.617 5.67272727,4.905 C5.52727273,5.049 5.34545455,5.121 5.16363636,5.121 Z M3.93636364,15.642 C3.75454545,15.642 3.57272727,15.57 3.42727273,15.426 C3.13636364,15.138 3.13636364,14.706 3.42727273,14.418 L4.88181818,12.978 C5.17272727,12.69 5.60909091,12.69 5.9,12.978 C6.19090909,13.266 6.19090909,13.698 5.9,13.986 L4.44545455,15.426 C4.3,15.606 4.11818182,15.642 3.93636364,15.642 Z M14.3363636,5.382 C14.1545455,5.382 13.9727273,5.31 13.8272727,5.166 C13.5363636,4.878 13.5363636,4.446 13.8272727,4.158 L15.2818182,2.718 C15.5727273,2.43 16.0090909,2.43 16.3,2.718 C16.5909091,3.006 16.5909091,3.438 16.3,3.726 L14.8454545,5.166 C14.7,5.31 14.5181818,5.382 14.3363636,5.382 Z",
  id: "Combined-Shape"
})), /*#__PURE__*/React__default.createElement("g", {
  id: "Group",
  transform: "translate(0.909091, 8.325000)"
}), /*#__PURE__*/React__default.createElement("g", {
  id: "Group",
  transform: "translate(3.181818, 2.025000)"
}), /*#__PURE__*/React__default.createElement("g", {
  id: "Group",
  transform: "translate(3.409091, 2.475000)"
}))))));

var SearchIconSvg = (props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React__default.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Input-field/-With--icon",
  transform: "translate(-304.000000, -40.000000)",
  className: "motorway-svg-stroke"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Group-4",
  transform: "translate(304.000000, 40.000000)"
}, /*#__PURE__*/React__default.createElement("circle", {
  id: "Oval-32",
  strokeWidth: "2",
  cx: "6",
  cy: "6",
  r: "5"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M9.28688623,11.5633238 L9.28688623,13.1633238 L14.8068081,13.1633238 C15.2486359,13.1633238 15.6068081,12.8051516 15.6068081,12.3633238 C15.6068081,11.921496 15.2486359,11.5633238 14.8068081,11.5633238 L9.28688623,11.5633238 Z",
  id: "Rectangle",
  className: "motorway-svg-fill",
  transform: "translate(12.446847, 12.363324) rotate(47.000000) translate(-12.446847, -12.363324) "
}))))));

export { AddIconSvg as A, DownIconSvg as D, LoadingIconSvg as L, SearchIconSvg as S };
